var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10.5054L13.6444 4.02772V4.03327C13.2111 3.58883 12.5056 3.58883 12.0667 4.02216L0 16.0498V1.11109C0 0.499992 0.5 0 1.11111 0H18.8889C19.5 0 20 0.499992 20 1.11109V10.5054ZM1.54999 5.36103C1.54999 6.58879 2.54443 7.58322 3.77221 7.58322C4.99999 7.58322 5.99443 6.58879 5.99443 5.36103C5.99443 4.13327 4.99999 3.13884 3.77221 3.13884C2.54443 3.13884 1.54999 4.13327 1.54999 5.36103ZM0 18.8889V18.4L12.05 6.38356C12.4889 5.95024 13.1944 5.95579 13.6278 6.39468L20 12.8835V18.8889C20 19.5 19.5 20 18.8889 20H1.11111C0.5 20 0 19.5 0 18.8889Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageMedium);
export default __webpack_public_path__ + "static/media/image-medium.a33f5db2a94b1506f4062ee533faf22c.svg";
export { ForwardRef as ReactComponent };